import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PageShell from "../components/PageShell";
import { ArrowLeftIcon } from "../components/Icons";
import "./GreetingCard.css";

const GreetingCard = () => {
  const { festival } = useParams();
  const navigate = useNavigate();
  const [isGenerating, setIsGenerating] = useState(false);

  const handleGenerate = async () => {
    setIsGenerating(true);
    // Navigate to AI Wishes page with festival context
    setTimeout(() => {
      navigate(`/ai-wishes?festival=${encodeURIComponent(festival)}`);
      setIsGenerating(false);
    }, 1000);
  };

  return (
    <PageShell
      title={`${festival} Greeting Card`}
      subtitle="Generate a personalized card and refine it using AI."
      breadcrumbs={
        <button
          className="btn btn--ghost"
          type="button"
          onClick={() => navigate("/select-festival")}
        >
          <ArrowLeftIcon className="icon" />
          Back
        </button>
      }
    >
      <div className="greetHero">
        <div className="greetHero__panel">
          <div className="greetHero__kicker">AI-powered card generation</div>
          <h2 className="greetHero__title">Create your greeting card</h2>
          <p className="greetHero__desc">
            Create a high-quality {festival} greeting card in seconds. You can refine both the
            message and the image after generation.
          </p>

          <div className="greetHero__actions">
            <button
              className="btn btn--primary"
              onClick={handleGenerate}
              disabled={isGenerating}
              type="button"
            >
              {isGenerating ? "Generating…" : "Generate greeting card"}
            </button>
            <button
              className="btn btn--secondary"
              type="button"
              onClick={() => navigate("/select-festival")}
            >
              Choose another occasion
            </button>
          </div>
        </div>

        <div className="greetHero__preview">
          <div className="greetPreview">
            <div className="greetPreview__top">
              <div className="pill">Preview</div>
              <div className="pill">{festival}</div>
            </div>
            <div className="greetPreview__card" aria-hidden="true">
              <div className="greetPreview__spark" />
              <div className="greetPreview__line" />
              <div className="greetPreview__line" />
              <div className="greetPreview__line short" />
            </div>
          </div>
        </div>
      </div>
    </PageShell>
  );
};

export default GreetingCard;

